import { BadgeStatut, type StatutBadge } from '@lakou/ui';
import type { HTMLAttributes, ReactNode } from 'react';

/**
 * Pastille d'état des écrans : un habillage de `BadgeStatut` du kit `@lakou/ui` (ovale, point de couleur, couleurs AA du kit).
 * Les écrans nomment un ton ; le kit porte la forme et les couleurs, il n'y a plus de pastille maison.
 */
export const TONS_PASTILLE = {
  bloque: 'bloque',
  'bonne-voie': 'verifie',
  attention: 'en_attente',
  info: 'en_cours',
  neutre: 'en_attente',
  equipe: 'en_cours',
} as const satisfies Record<string, StatutBadge>;

export type TonPastille = keyof typeof TONS_PASTILLE;

export function Pastille({
  ton,
  children,
  ...attributs
}: { ton: TonPastille; children: ReactNode } & Omit<HTMLAttributes<HTMLSpanElement>, 'style' | 'children'>) {
  return <BadgeStatut statut={TONS_PASTILLE[ton]} libelle={children} {...attributs} />;
}
